import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
  async health() {
    const r = await axios.get(`${API}/health`);
    return r.data;
  },
  async publicConfig() {
    const r = await axios.get(`${API}/config/public`);
    return r.data;
  },
  async questionnaire() {
    const r = await axios.get(`${API}/questionnaire`);
    return r.data;
  },
  async preview(answers) {
    const r = await axios.post(`${API}/preview`, { answers });
    return r.data;
  },
  async submit(payload) {
    const r = await axios.post(`${API}/submit`, payload);
    return r.data;
  },
  async resume(token) {
    const r = await axios.get(`${API}/resume/${token}`);
    return r.data;
  },
  reportPdfUrl() {
    return `${API}/report/pdf`;
  },
  async downloadPdf({ answers, lead, ref }) {
    const r = await axios.post(`${API}/report/pdf`, { answers, lead, ref }, { responseType: "blob" });
    const blob = new Blob([r.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ariovis-roadmap-iam-${ref || "rapport"}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
